<!-- <div class="col-6"> -->
    <!-- <div class="UNFAPP-lvcls-vwtcr-box">
        <div class="vwtcr-img-frame">
            <img class="vwtcr-img" [src]="teacherData?.profileImage" (error)="_helper.profileImgError($event)" alt="{{teacherData?.name}}" />
        </div>
        <div class="vwtcr-info-area">
            <h3 class="vwtcr-hdng">{{teacherData?.name}}</h3>
            <ng-container  *ngIf="teacherData?.subjects?.length > 0">
                <ng-container *ngFor="let sub of teacherData?.subjects">
                    <div class="lvcls-curs-tag">{{sub}} Expert</div>
                </ng-container>
            </ng-container>
            <p class="vwtcr-box-para">{{teacherData?.description}}</p>
        </div>
    </div> -->
<!-- </div> -->
<div class="UNFAPP-new-carousl m-hide UNFAPP-tutorcarousl" *ngIf="teacherData.length > 0">
<carousel 
        #myCarousel 
        [height]="180" 
        [margin]="30"
        [cellWidth]="450" 
        [overflowCellsLimit]="2" >
            <ng-container *ngFor="let teachers of teacherData">
                <div class="carousel-cell">
                    <div class="UNFAPP-lvcls-vwtcr-box">
                        <div class="vwtcr-img-frame">
                            <img class="vwtcr-img" [src]="teachers?.photo || teachers?.profileImage" (error)="_helper.profileImgError($event)" alt="" />
                        </div>
                        <div class="vwtcr-info-area">
                            <h3 class="vwtcr-hdng" >{{teachers?.firstName || teachers?.obj?.firstName}}&nbsp;{{teachers?.lastName || teachers?.obj?.lastName}}</h3>
                            <ng-container *ngIf="teachers?.teachingSubjects?.length;else otherTeacherTemplate"  >
                                <div class="lvcls-curs-tag" *ngFor="let sub of teachers?.teachingSubjects">{{sub}} Expert</div>
                            </ng-container>
                            <ng-template #otherTeacherTemplate>
                                <ng-container  *ngFor="let sub of teachers?.obj?.subjects">
                                    <div class="lvcls-curs-tag">{{sub}} Expert</div>
                                </ng-container>
                            </ng-template>
                            <p class="vwtcr-box-para" matTooltip="{{teachers?.description}}">{{(teachers?.description | slice:0:75)+(teachers?.description?.length > 75 ? '...' : '')}}</p>
                        </div>
                    </div>
                </div>
            </ng-container>
        </carousel>
        
</div>

<div class="UNFAPP-new-carousl d-hide UNFAPP-tutorcarousl"  *ngIf="teacherData.length > 0">
    <div class="row UNFAPP-lvcls-mob-rw-scrll">
        <div class="col-11" *ngFor="let teachers of teacherData">
            <div class="UNFAPP-lvcls-vwtcr-box">
                <div class="vwtcr-img-frame">
                    <img class="vwtcr-img" [src]="teachers?.photo || teachers?.profileImage" alt="" />
                </div>
                <div class="vwtcr-info-area">
                    <h3 class="vwtcr-hdng">{{teachers?.firstName || teachers?.obj?.firstName}}&nbsp;{{teachers?.lastName || teachers?.obj?.lastName}}</h3>
                    <ng-container *ngIf="teachers?.teachingSubjects?.length;else otherTeacherTemplate"  >
                        <div class="lvcls-curs-tag" *ngFor="let sub of teachers?.teachingSubjects">{{sub}} Expert</div>
                    </ng-container>
                    <ng-template #otherTeacherTemplate>
                        <ng-container  *ngFor="let sub of teachers?.obj?.subjects">
                            <div class="lvcls-curs-tag">{{sub}} Expert</div>
                        </ng-container>
                    </ng-template>
                    <p class="vwtcr-box-para" matTooltip="{{teachers?.description}}">{{(teachers?.description | slice:0:75)+(teachers?.description?.length > 75 ? '...' : '')}}</p>
                </div>
            </div>
        </div>
    </div>
</div>
